<template>
  <div>
    <div class="hidden md:block">
      <router-view />
    </div>
    <div class="bg-pink-50 block md:hidden h-screen">
      <div class="h-screen px-6 py-8 flex flex-col items-center justify-center">
        <div class="">
          <p class="text-pink-700 text-xl font-bold">Oops!</p>
          <p class="text-pink-700 text-3xl font-extrabold py-3">Apologies</p>
          <p class="text-sm">
            I didn't get a change to make sure I optimize this and make it
            responsive for small devices. Hope you don't mind checking it on
            <span class="underline underline-offset-4 font-bold">
              larger device like a laptop, or tablet</span
            >. Thanks for your understanding.
          </p>
          <div class="my-4">
            <a
              target="__blank"
              href="https://www.linkedin.com/in/nehemieniyomahoro/details/experience/"
            >
              <button
                type="button"
                class="transition text-white bg-pink-700 hover:bg-pink-800 focus:ring-4 focus:outline-none focus:ring-pink-800 font-medium text-lg rounded px-4 py-2.5 text-center mr-3 md:mr-0"
              >
                Check LinkedIn
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss">
#app {
  // Improve this
  // max-width: 1200px;
  margin: auto;
}
body {
  background-color: $white;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
}
body::-webkit-scrollbar {
  width: 20px;
  cursor: pointer;
  /*background-color: rgba(229, 231, 235, var(--bg-opacity));*/
}
body::-webkit-scrollbar-button {
  display: none;
}
body::-webkit-scrollbar-track {
  background-color: transparent;
  cursor: pointer;
  /*background: red;*/
}
body::-webkit-scrollbar-thumb {
  cursor: pointer;
  background-color: saturate(
    $color: rgba($color: $dark-blue, $alpha: 0.2),
    $amount: 30%
  );
  border-radius: 30px;
  border: 3px solid $white;
}
body::-webkit-scrollbar-button {
  background-color: transparent;
}
</style>
